import { Checkbox, createStyles, Theme, withStyles } from '@material-ui/core';

export const CompactCheckbox = withStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: 0,
    },
  }),
)(Checkbox);
